import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { open } from 'store/modules/modal';
import Sports from '../components/Sports';
import API from '../../../../utils/api';

const refreshSportsList = props => {
  API.getSports({
    select: 'name active logo',
    populate: ['logo'],
  }).then(({ data }) => {
    if (data && data.docs) {
      props.setSports(data.docs);
    }
  });
};

const mapStateToProps = ({ auth }) => ({ auth });
const mapDispatchToProps = dispatch => ({ dispatch });

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('sports', 'setSports', []),
  withState('dialogOpen', 'setDialogOpen', false),
  withState('alertOpen', 'setAlertOpen', false),
  withState('errorMessage', 'setErrorMessage', ''),
  withHandlers({
    refreshSports: props => () => refreshSportsList(props),

    createSport: props => newSport =>
      API.createSport(newSport).then(() => refreshSportsList(props)),

    editSport: props => (selectedSport, newSport) =>
      API.editSport(selectedSport, newSport).then(() => refreshSportsList(props)),
  }),
  withHandlers({
    confirmDeleteSport: props => row => {
      props.dispatch(
        open({
          modalType: 'confirm',
          modalProps: {
            message: `Delete Sport ${row.name}?`,
            keyId: row._id,
            handleYes: () => API.deleteSport(row._id).then(props.refreshSports),
          },
        })
      );
    },
    changeDialogState: props => state => {
      props.setDialogOpen(state);
      props.setErrorMessage('');
    },
    changeAlertState: props => props.setAlertOpen,
    updateErrorMessage: props => props.setErrorMessage,
  }),
  lifecycle({
    componentDidMount() {
      refreshSportsList(this.props);
    },
  })
);

export default enhance(Sports);
